package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * British Indian Ocean Territory Flag (20x15dp)
 *
 * - ISO Alpha-2: IO
 * - ISO Alpha-3: IOT
 * - ISO Numeric: 086
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.BritishIndianOceanTerritory: ImageVector by lazy {
    ImageVector.Builder(
        name = "British Indian Ocean Territory:IO:IOT:086:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(15f)
                horizontalLineTo(20f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(-0.941f, 1.657f)
                lineTo(-0.012f, 2.543f)
                curveTo(0.756f, 1.817f, 1.48f, 1.475f, 2.168f, 1.475f)
                curveTo(2.501f, 1.475f, 2.642f, 1.555f, 3.026f, 1.918f)
                curveTo(3.634f, 2.493f, 4.044f, 2.725f, 4.813f, 2.725f)
                curveTo(5.582f, 2.725f, 5.992f, 2.493f, 6.6f, 1.918f)
                curveTo(6.984f, 1.555f, 7.125f, 1.475f, 7.458f, 1.475f)
                curveTo(7.79f, 1.475f, 7.932f, 1.555f, 8.315f, 1.918f)
                curveTo(8.924f, 2.493f, 9.333f, 2.725f, 10.102f, 2.725f)
                curveTo(10.872f, 2.725f, 11.281f, 2.493f, 11.889f, 1.918f)
                curveTo(12.273f, 1.555f, 12.415f, 1.475f, 12.747f, 1.475f)
                curveTo(13.08f, 1.475f, 13.221f, 1.555f, 13.605f, 1.918f)
                curveTo(14.213f, 2.493f, 14.622f, 2.725f, 15.392f, 2.725f)
                curveTo(16.161f, 2.725f, 16.57f, 2.493f, 17.179f, 1.918f)
                curveTo(17.562f, 1.555f, 17.704f, 1.475f, 18.036f, 1.475f)
                curveTo(18.725f, 1.475f, 19.449f, 1.817f, 20.216f, 2.543f)
                lineTo(21.146f, 1.657f)
                curveTo(20.15f, 0.716f, 19.111f, 0.225f, 18.036f, 0.225f)
                curveTo(17.267f, 0.225f, 16.858f, 0.457f, 16.249f, 1.032f)
                curveTo(15.866f, 1.395f, 15.724f, 1.475f, 15.392f, 1.475f)
                curveTo(15.059f, 1.475f, 14.918f, 1.395f, 14.534f, 1.032f)
                curveTo(13.926f, 0.457f, 13.517f, 0.225f, 12.747f, 0.225f)
                curveTo(11.978f, 0.225f, 11.568f, 0.457f, 10.96f, 1.032f)
                curveTo(10.576f, 1.395f, 10.435f, 1.475f, 10.102f, 1.475f)
                curveTo(9.77f, 1.475f, 9.628f, 1.395f, 9.245f, 1.032f)
                curveTo(8.637f, 0.457f, 8.227f, 0.225f, 7.458f, 0.225f)
                curveTo(6.688f, 0.225f, 6.279f, 0.457f, 5.671f, 1.032f)
                curveTo(5.287f, 1.395f, 5.146f, 1.475f, 4.813f, 1.475f)
                curveTo(4.481f, 1.475f, 4.339f, 1.395f, 3.955f, 1.032f)
                curveTo(3.347f, 0.457f, 2.938f, 0.225f, 2.168f, 0.225f)
                curveTo(1.093f, 0.225f, 0.055f, 0.716f, -0.941f, 1.657f)
                close()
                moveTo(-0.012f, 5.043f)
                lineTo(-0.941f, 4.157f)
                curveTo(0.055f, 3.216f, 1.093f, 2.725f, 2.168f, 2.725f)
                curveTo(2.938f, 2.725f, 3.347f, 2.957f, 3.955f, 3.532f)
                curveTo(4.339f, 3.895f, 4.481f, 3.975f, 4.813f, 3.975f)
                curveTo(5.146f, 3.975f, 5.287f, 3.895f, 5.671f, 3.532f)
                curveTo(6.279f, 2.957f, 6.688f, 2.725f, 7.458f, 2.725f)
                curveTo(8.227f, 2.725f, 8.637f, 2.957f, 9.245f, 3.532f)
                curveTo(9.628f, 3.895f, 9.77f, 3.975f, 10.102f, 3.975f)
                curveTo(10.435f, 3.975f, 10.576f, 3.895f, 10.96f, 3.532f)
                curveTo(11.568f, 2.957f, 11.978f, 2.725f, 12.747f, 2.725f)
                curveTo(13.517f, 2.725f, 13.926f, 2.957f, 14.534f, 3.532f)
                curveTo(14.918f, 3.895f, 15.059f, 3.975f, 15.392f, 3.975f)
                curveTo(15.724f, 3.975f, 15.866f, 3.895f, 16.249f, 3.532f)
                curveTo(16.858f, 2.957f, 17.267f, 2.725f, 18.036f, 2.725f)
                curveTo(19.111f, 2.725f, 20.15f, 3.216f, 21.146f, 4.157f)
                lineTo(20.216f, 5.043f)
                curveTo(19.449f, 4.317f, 18.725f, 3.975f, 18.036f, 3.975f)
                curveTo(17.704f, 3.975f, 17.562f, 4.055f, 17.179f, 4.418f)
                curveTo(16.57f, 4.993f, 16.161f, 5.225f, 15.392f, 5.225f)
                curveTo(14.622f, 5.225f, 14.213f, 4.993f, 13.605f, 4.418f)
                curveTo(13.221f, 4.055f, 13.08f, 3.975f, 12.747f, 3.975f)
                curveTo(12.415f, 3.975f, 12.273f, 4.055f, 11.889f, 4.418f)
                curveTo(11.281f, 4.993f, 10.872f, 5.225f, 10.102f, 5.225f)
                curveTo(9.333f, 5.225f, 8.924f, 4.993f, 8.315f, 4.418f)
                curveTo(7.932f, 4.055f, 7.79f, 3.975f, 7.458f, 3.975f)
                curveTo(7.125f, 3.975f, 6.984f, 4.055f, 6.6f, 4.418f)
                curveTo(5.992f, 4.993f, 5.582f, 5.225f, 4.813f, 5.225f)
                curveTo(4.044f, 5.225f, 3.634f, 4.993f, 3.026f, 4.418f)
                curveTo(2.642f, 4.055f, 2.501f, 3.975f, 2.168f, 3.975f)
                curveTo(1.48f, 3.975f, 0.756f, 4.317f, -0.012f, 5.043f)
                close()
                moveTo(-0.012f, 7.543f)
                lineTo(-0.941f, 6.657f)
                curveTo(0.055f, 5.716f, 1.093f, 5.225f, 2.168f, 5.225f)
                curveTo(2.938f, 5.225f, 3.347f, 5.457f, 3.955f, 6.032f)
                curveTo(4.339f, 6.395f, 4.481f, 6.475f, 4.813f, 6.475f)
                curveTo(5.146f, 6.475f, 5.287f, 6.395f, 5.671f, 6.032f)
                curveTo(6.279f, 5.457f, 6.688f, 5.225f, 7.458f, 5.225f)
                curveTo(8.227f, 5.225f, 8.637f, 5.457f, 9.245f, 6.032f)
                curveTo(9.628f, 6.395f, 9.77f, 6.475f, 10.102f, 6.475f)
                curveTo(10.435f, 6.475f, 10.576f, 6.395f, 10.96f, 6.032f)
                curveTo(11.568f, 5.457f, 11.978f, 5.225f, 12.747f, 5.225f)
                curveTo(13.517f, 5.225f, 13.926f, 5.457f, 14.534f, 6.032f)
                curveTo(14.918f, 6.395f, 15.059f, 6.475f, 15.392f, 6.475f)
                curveTo(15.724f, 6.475f, 15.866f, 6.395f, 16.249f, 6.032f)
                curveTo(16.858f, 5.457f, 17.267f, 5.225f, 18.036f, 5.225f)
                curveTo(19.111f, 5.225f, 20.15f, 5.716f, 21.146f, 6.657f)
                lineTo(20.216f, 7.543f)
                curveTo(19.449f, 6.817f, 18.725f, 6.475f, 18.036f, 6.475f)
                curveTo(17.704f, 6.475f, 17.562f, 6.555f, 17.179f, 6.918f)
                curveTo(16.57f, 7.493f, 16.161f, 7.725f, 15.392f, 7.725f)
                curveTo(14.622f, 7.725f, 14.213f, 7.493f, 13.605f, 6.918f)
                curveTo(13.221f, 6.555f, 13.08f, 6.475f, 12.747f, 6.475f)
                curveTo(12.415f, 6.475f, 12.273f, 6.555f, 11.889f, 6.918f)
                curveTo(11.281f, 7.493f, 10.872f, 7.725f, 10.102f, 7.725f)
                curveTo(9.333f, 7.725f, 8.924f, 7.493f, 8.315f, 6.918f)
                curveTo(7.932f, 6.555f, 7.79f, 6.475f, 7.458f, 6.475f)
                curveTo(7.125f, 6.475f, 6.984f, 6.555f, 6.6f, 6.918f)
                curveTo(5.992f, 7.493f, 5.582f, 7.725f, 4.813f, 7.725f)
                curveTo(4.044f, 7.725f, 3.634f, 7.493f, 3.026f, 6.918f)
                curveTo(2.642f, 6.555f, 2.501f, 6.475f, 2.168f, 6.475f)
                curveTo(1.48f, 6.475f, 0.756f, 6.817f, -0.012f, 7.543f)
                close()
                moveTo(-0.012f, 10.043f)
                lineTo(-0.941f, 9.157f)
                curveTo(0.055f, 8.216f, 1.093f, 7.725f, 2.168f, 7.725f)
                curveTo(2.938f, 7.725f, 3.347f, 7.957f, 3.955f, 8.532f)
                curveTo(4.339f, 8.895f, 4.481f, 8.975f, 4.813f, 8.975f)
                curveTo(5.146f, 8.975f, 5.287f, 8.895f, 5.671f, 8.532f)
                curveTo(6.279f, 7.957f, 6.688f, 7.725f, 7.458f, 7.725f)
                curveTo(8.227f, 7.725f, 8.637f, 7.957f, 9.245f, 8.532f)
                curveTo(9.628f, 8.895f, 9.77f, 8.975f, 10.102f, 8.975f)
                curveTo(10.435f, 8.975f, 10.576f, 8.895f, 10.96f, 8.532f)
                curveTo(11.568f, 7.957f, 11.978f, 7.725f, 12.747f, 7.725f)
                curveTo(13.517f, 7.725f, 13.926f, 7.957f, 14.534f, 8.532f)
                curveTo(14.918f, 8.895f, 15.059f, 8.975f, 15.392f, 8.975f)
                curveTo(15.724f, 8.975f, 15.866f, 8.895f, 16.249f, 8.532f)
                curveTo(16.858f, 7.957f, 17.267f, 7.725f, 18.036f, 7.725f)
                curveTo(19.111f, 7.725f, 20.15f, 8.216f, 21.146f, 9.157f)
                lineTo(20.216f, 10.043f)
                curveTo(19.449f, 9.317f, 18.725f, 8.975f, 18.036f, 8.975f)
                curveTo(17.704f, 8.975f, 17.562f, 9.055f, 17.179f, 9.418f)
                curveTo(16.57f, 9.993f, 16.161f, 10.225f, 15.392f, 10.225f)
                curveTo(14.622f, 10.225f, 14.213f, 9.993f, 13.605f, 9.418f)
                curveTo(13.221f, 9.055f, 13.08f, 8.975f, 12.747f, 8.975f)
                curveTo(12.415f, 8.975f, 12.273f, 9.055f, 11.889f, 9.418f)
                curveTo(11.281f, 9.993f, 10.872f, 10.225f, 10.102f, 10.225f)
                curveTo(9.333f, 10.225f, 8.924f, 9.993f, 8.315f, 9.418f)
                curveTo(7.932f, 9.055f, 7.79f, 8.975f, 7.458f, 8.975f)
                curveTo(7.125f, 8.975f, 6.984f, 9.055f, 6.6f, 9.418f)
                curveTo(5.992f, 9.993f, 5.582f, 10.225f, 4.813f, 10.225f)
                curveTo(4.044f, 10.225f, 3.634f, 9.993f, 3.026f, 9.418f)
                curveTo(2.642f, 9.055f, 2.501f, 8.975f, 2.168f, 8.975f)
                curveTo(1.48f, 8.975f, 0.756f, 9.317f, -0.012f, 10.043f)
                close()
                moveTo(-0.012f, 12.543f)
                lineTo(-0.941f, 11.657f)
                curveTo(0.055f, 10.716f, 1.093f, 10.225f, 2.168f, 10.225f)
                curveTo(2.938f, 10.225f, 3.347f, 10.457f, 3.955f, 11.032f)
                curveTo(4.339f, 11.395f, 4.481f, 11.475f, 4.813f, 11.475f)
                curveTo(5.146f, 11.475f, 5.287f, 11.395f, 5.671f, 11.032f)
                curveTo(6.279f, 10.457f, 6.688f, 10.225f, 7.458f, 10.225f)
                curveTo(8.227f, 10.225f, 8.637f, 10.457f, 9.245f, 11.032f)
                curveTo(9.628f, 11.395f, 9.77f, 11.475f, 10.102f, 11.475f)
                curveTo(10.435f, 11.475f, 10.576f, 11.395f, 10.96f, 11.032f)
                curveTo(11.568f, 10.457f, 11.978f, 10.225f, 12.747f, 10.225f)
                curveTo(13.517f, 10.225f, 13.926f, 10.457f, 14.534f, 11.032f)
                curveTo(14.918f, 11.395f, 15.059f, 11.475f, 15.392f, 11.475f)
                curveTo(15.724f, 11.475f, 15.866f, 11.395f, 16.249f, 11.032f)
                curveTo(16.858f, 10.457f, 17.267f, 10.225f, 18.036f, 10.225f)
                curveTo(19.111f, 10.225f, 20.15f, 10.716f, 21.146f, 11.657f)
                lineTo(20.216f, 12.543f)
                curveTo(19.449f, 11.817f, 18.725f, 11.475f, 18.036f, 11.475f)
                curveTo(17.704f, 11.475f, 17.562f, 11.555f, 17.179f, 11.918f)
                curveTo(16.57f, 12.493f, 16.161f, 12.725f, 15.392f, 12.725f)
                curveTo(14.622f, 12.725f, 14.213f, 12.493f, 13.605f, 11.918f)
                curveTo(13.221f, 11.555f, 13.08f, 11.475f, 12.747f, 11.475f)
                curveTo(12.415f, 11.475f, 12.273f, 11.555f, 11.889f, 11.918f)
                curveTo(11.281f, 12.493f, 10.872f, 12.725f, 10.102f, 12.725f)
                curveTo(9.333f, 12.725f, 8.924f, 12.493f, 8.315f, 11.918f)
                curveTo(7.932f, 11.555f, 7.79f, 11.475f, 7.458f, 11.475f)
                curveTo(7.125f, 11.475f, 6.984f, 11.555f, 6.6f, 11.918f)
                curveTo(5.992f, 12.493f, 5.582f, 12.725f, 4.813f, 12.725f)
                curveTo(4.044f, 12.725f, 3.634f, 12.493f, 3.026f, 11.918f)
                curveTo(2.642f, 11.555f, 2.501f, 11.475f, 2.168f, 11.475f)
                curveTo(1.48f, 11.475f, 0.756f, 11.817f, -0.012f, 12.543f)
                close()
                moveTo(-0.012f, 15.043f)
                lineTo(-0.941f, 14.157f)
                curveTo(0.055f, 13.216f, 1.093f, 12.725f, 2.168f, 12.725f)
                curveTo(2.938f, 12.725f, 3.347f, 12.957f, 3.955f, 13.532f)
                curveTo(4.339f, 13.895f, 4.481f, 13.975f, 4.813f, 13.975f)
                curveTo(5.146f, 13.975f, 5.287f, 13.895f, 5.671f, 13.532f)
                curveTo(6.279f, 12.957f, 6.688f, 12.725f, 7.458f, 12.725f)
                curveTo(8.227f, 12.725f, 8.637f, 12.957f, 9.245f, 13.532f)
                curveTo(9.628f, 13.895f, 9.77f, 13.975f, 10.102f, 13.975f)
                curveTo(10.435f, 13.975f, 10.576f, 13.895f, 10.96f, 13.532f)
                curveTo(11.568f, 12.957f, 11.978f, 12.725f, 12.747f, 12.725f)
                curveTo(13.517f, 12.725f, 13.926f, 12.957f, 14.534f, 13.532f)
                curveTo(14.918f, 13.895f, 15.059f, 13.975f, 15.392f, 13.975f)
                curveTo(15.724f, 13.975f, 15.866f, 13.895f, 16.249f, 13.532f)
                curveTo(16.858f, 12.957f, 17.267f, 12.725f, 18.036f, 12.725f)
                curveTo(19.111f, 12.725f, 20.15f, 13.216f, 21.146f, 14.157f)
                lineTo(20.216f, 15.043f)
                curveTo(19.449f, 14.317f, 18.725f, 13.975f, 18.036f, 13.975f)
                curveTo(17.704f, 13.975f, 17.562f, 14.055f, 17.179f, 14.418f)
                curveTo(16.57f, 14.993f, 16.161f, 15.225f, 15.392f, 15.225f)
                curveTo(14.622f, 15.225f, 14.213f, 14.993f, 13.605f, 14.418f)
                curveTo(13.221f, 14.055f, 13.08f, 13.975f, 12.747f, 13.975f)
                curveTo(12.415f, 13.975f, 12.273f, 14.055f, 11.889f, 14.418f)
                curveTo(11.281f, 14.993f, 10.872f, 15.225f, 10.102f, 15.225f)
                curveTo(9.333f, 15.225f, 8.924f, 14.993f, 8.315f, 14.418f)
                curveTo(7.932f, 14.055f, 7.79f, 13.975f, 7.458f, 13.975f)
                curveTo(7.125f, 13.975f, 6.984f, 14.055f, 6.6f, 14.418f)
                curveTo(5.992f, 14.993f, 5.582f, 15.225f, 4.813f, 15.225f)
                curveTo(4.044f, 15.225f, 3.634f, 14.993f, 3.026f, 14.418f)
                curveTo(2.642f, 14.055f, 2.501f, 13.975f, 2.168f, 13.975f)
                curveTo(1.48f, 13.975f, 0.756f, 14.317f, -0.012f, 15.043f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(11f)
                verticalLineToRelative(9f)
                horizontalLineToRelative(-11f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(11f)
                verticalLineToRelative(9f)
                horizontalLineToRelative(-11f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(-1.253f, 8.125f)
                lineTo(1.223f, 9.211f)
                lineTo(11.306f, 1.18f)
                lineTo(12.612f, -0.433f)
                lineTo(9.965f, -0.796f)
                lineTo(5.852f, 2.665f)
                lineTo(2.542f, 4.996f)
                lineTo(-1.253f, 8.125f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-0.914f, 8.886f)
                lineTo(0.347f, 9.516f)
                lineTo(12.143f, -0.583f)
                horizontalLineTo(10.372f)
                lineTo(-0.914f, 8.886f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(12.503f, 8.125f)
                lineTo(10.306f, 9.521f)
                lineTo(-0.056f, 1.18f)
                lineTo(-1.362f, -0.433f)
                lineTo(1.285f, -0.796f)
                lineTo(5.398f, 2.665f)
                lineTo(8.708f, 4.996f)
                lineTo(12.503f, 8.125f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(12.418f, 8.671f)
                lineTo(11.157f, 9.301f)
                lineTo(6.134f, 4.977f)
                lineTo(4.645f, 4.494f)
                lineTo(-1.488f, -0.427f)
                horizontalLineTo(0.283f)
                lineTo(6.413f, 4.377f)
                lineTo(8.041f, 4.957f)
                lineTo(12.418f, 8.671f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6f, 0f)
                horizontalLineTo(5f)
                verticalLineTo(4f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                horizontalLineTo(5f)
                verticalLineTo(9f)
                horizontalLineTo(6f)
                verticalLineTo(5f)
                horizontalLineTo(11f)
                verticalLineTo(4f)
                horizontalLineTo(6f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.063f, 0f)
                horizontalLineTo(6.938f)
                verticalLineTo(3.063f)
                lineTo(11f, 3f)
                verticalLineTo(5.875f)
                lineTo(6.938f, 5.938f)
                verticalLineTo(9f)
                horizontalLineTo(4.063f)
                verticalLineTo(5.938f)
                lineTo(0f, 5.875f)
                verticalLineTo(3f)
                lineTo(4.063f, 3.063f)
                verticalLineTo(0f)
                close()
                moveTo(5f, 4f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                horizontalLineTo(5f)
                verticalLineTo(9f)
                horizontalLineTo(6f)
                verticalLineTo(5f)
                horizontalLineTo(11f)
                verticalLineTo(4f)
                horizontalLineTo(6f)
                verticalLineTo(0f)
                horizontalLineTo(5f)
                verticalLineTo(4f)
                close()
            }
        }
        path(fill = SolidColor(Color(0xFFD86D00))) {
            moveTo(13.063f, 5.862f)
            lineTo(13.063f, 5.862f)
            arcTo(0.313f, 0.313f, 0f, isMoreThanHalf = false, isPositiveArc = true, 13.375f, 6.174f)
            lineTo(13.375f, 13.438f)
            arcTo(0.313f, 0.313f, 0f, isMoreThanHalf = false, isPositiveArc = true, 13.063f, 13.75f)
            lineTo(13.063f, 13.75f)
            arcTo(0.313f, 0.313f, 0f, isMoreThanHalf = false, isPositiveArc = true, 12.75f, 13.438f)
            lineTo(12.75f, 6.174f)
            arcTo(0.313f, 0.313f, 0f, isMoreThanHalf = false, isPositiveArc = true, 13.063f, 5.862f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF449A01)),
            stroke = SolidColor(Color.White),
            strokeLineWidth = 0.15f
        ) {
            moveTo(12.753f, 1.286f)
            curveTo(13.391f, 2.162f, 13.472f, 3.338f, 13.391f, 4.391f)
            lineTo(12.893f, 4.355f)
            curveTo(12.97f, 3.35f, 12.753f, 1.286f, 12.753f, 1.286f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF449A01)),
            stroke = SolidColor(Color.White),
            strokeLineWidth = 0.15f
        ) {
            moveTo(13.567f, 4.615f)
            lineTo(13.107f, 4.425f)
            curveTo(13.55f, 3.022f, 15.762f, 1.827f, 15.762f, 1.827f)
            curveTo(14.771f, 2.301f, 14.435f, 3.584f, 13.567f, 4.615f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF449A01)),
            stroke = SolidColor(Color.White),
            strokeLineWidth = 0.15f
        ) {
            moveTo(13.36f, 4.906f)
            lineTo(13.119f, 4.481f)
            curveTo(14.301f, 3.659f, 16.211f, 3.482f, 16.211f, 3.482f)
            curveTo(15.226f, 3.762f, 14.231f, 4.44f, 13.36f, 4.906f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF449A01)),
            stroke = SolidColor(Color.White),
            strokeLineWidth = 0.15f
        ) {
            moveTo(13.053f, 5.113f)
            lineTo(13.261f, 4.672f)
            curveTo(15.574f, 5.39f, 15.913f, 6.59f, 15.913f, 6.59f)
            curveTo(15.609f, 6.322f, 14.645f, 5.822f, 13.053f, 5.113f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF449A01)),
            stroke = SolidColor(Color.White),
            strokeLineWidth = 0.15f
        ) {
            moveTo(12.809f, 5.081f)
            lineTo(13.301f, 4.99f)
            curveTo(13.471f, 5.852f, 13.909f, 6.374f, 14.141f, 6.927f)
            curveTo(14.141f, 6.927f, 12.843f, 6.347f, 12.809f, 5.081f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF449A01)),
            stroke = SolidColor(Color.White),
            strokeLineWidth = 0.15f
        ) {
            moveTo(12.772f, 4.677f)
            lineTo(13.302f, 4.81f)
            curveTo(12.433f, 5.872f, 11.142f, 6.43f, 10.632f, 6.612f)
            curveTo(10.632f, 6.612f, 11.753f, 5.601f, 12.772f, 4.677f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF449A01)),
            stroke = SolidColor(Color.White),
            strokeLineWidth = 0.15f
        ) {
            moveTo(13.007f, 4.447f)
            lineTo(12.927f, 4.941f)
            curveTo(11.892f, 4.625f, 10.03f, 4.757f, 10.03f, 4.757f)
            curveTo(10.812f, 4.572f, 11.892f, 4.265f, 13.007f, 4.447f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFF449A01)),
            stroke = SolidColor(Color.White),
            strokeLineWidth = 0.15f
        ) {
            moveTo(13.097f, 4.195f)
            lineTo(12.893f, 4.638f)
            curveTo(11.366f, 3.978f, 10.55f, 2.743f, 10.55f, 2.743f)
            curveTo(10.601f, 2.97f, 11.748f, 3.611f, 13.097f, 4.195f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFF50100)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(14.945f, 9.567f)
            verticalLineTo(9.477f)
            curveTo(14.657f, 9.25f, 14.355f, 9.136f, 14.04f, 9.136f)
            curveTo(13.738f, 8.989f, 13.432f, 8.932f, 13.122f, 8.964f)
            curveTo(13.123f, 8.963f, 13.123f, 8.963f, 13.123f, 8.963f)
            curveTo(12.657f, 8.913f, 12.188f, 9.136f, 12.188f, 9.136f)
            curveTo(11.715f, 9.136f, 11.283f, 9.477f, 11.283f, 9.477f)
            verticalLineTo(9.567f)
            lineTo(11.848f, 10.191f)
            curveTo(11.848f, 10.191f, 12.007f, 10.792f, 13.12f, 10.651f)
            verticalLineTo(10.653f)
            curveTo(13.12f, 10.653f, 13.857f, 10.63f, 13.909f, 10.611f)
            curveTo(13.93f, 10.604f, 13.951f, 10.597f, 13.973f, 10.59f)
            curveTo(14.117f, 10.544f, 14.282f, 10.491f, 14.38f, 10.191f)
            lineTo(14.945f, 9.567f)
            close()
            moveTo(13.12f, 8.992f)
            curveTo(13.104f, 9.2f, 13.012f, 10.453f, 13.12f, 10.647f)
            verticalLineTo(8.992f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFECA00)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(12.2f, 8.866f)
            curveTo(12.26f, 8.664f, 12.366f, 8.595f, 12.622f, 8.595f)
            curveTo(12.781f, 8.595f, 12.901f, 8.636f, 12.984f, 8.716f)
            verticalLineTo(9.257f)
            horizontalLineTo(13.029f)
            verticalLineTo(9.312f)
            curveTo(12.999f, 9.339f, 12.984f, 9.393f, 12.996f, 9.452f)
            curveTo(12.999f, 9.472f, 13.006f, 9.49f, 13.014f, 9.506f)
            curveTo(12.993f, 9.498f, 12.97f, 9.494f, 12.945f, 9.494f)
            curveTo(12.868f, 9.494f, 12.805f, 9.535f, 12.805f, 9.586f)
            curveTo(12.805f, 9.637f, 12.868f, 9.679f, 12.945f, 9.679f)
            curveTo(13.022f, 9.679f, 13.085f, 9.637f, 13.085f, 9.586f)
            curveTo(13.085f, 9.612f, 13.101f, 9.635f, 13.127f, 9.652f)
            horizontalLineTo(13.058f)
            horizontalLineTo(13.056f)
            curveTo(13.056f, 9.791f, 12.991f, 9.88f, 12.895f, 9.88f)
            curveTo(12.827f, 9.88f, 12.78f, 9.846f, 12.745f, 9.771f)
            lineTo(12.649f, 9.563f)
            lineTo(12.639f, 9.796f)
            curveTo(12.635f, 9.878f, 12.603f, 9.91f, 12.522f, 9.91f)
            curveTo(12.444f, 9.91f, 12.388f, 9.857f, 12.349f, 9.737f)
            curveTo(12.361f, 9.739f, 12.373f, 9.74f, 12.385f, 9.74f)
            curveTo(12.462f, 9.74f, 12.525f, 9.699f, 12.525f, 9.648f)
            curveTo(12.525f, 9.597f, 12.462f, 9.555f, 12.385f, 9.555f)
            curveTo(12.368f, 9.555f, 12.351f, 9.557f, 12.336f, 9.561f)
            curveTo(12.342f, 9.537f, 12.343f, 9.508f, 12.337f, 9.478f)
            curveTo(12.322f, 9.403f, 12.27f, 9.349f, 12.22f, 9.359f)
            curveTo(12.17f, 9.368f, 12.141f, 9.438f, 12.156f, 9.514f)
            curveTo(12.159f, 9.533f, 12.166f, 9.551f, 12.174f, 9.567f)
            curveTo(12.153f, 9.56f, 12.13f, 9.555f, 12.105f, 9.555f)
            curveTo(12.028f, 9.555f, 11.965f, 9.597f, 11.965f, 9.648f)
            curveTo(11.965f, 9.699f, 12.028f, 9.74f, 12.105f, 9.74f)
            curveTo(12.168f, 9.74f, 12.221f, 9.713f, 12.239f, 9.676f)
            lineTo(12.234f, 9.73f)
            curveTo(12.222f, 9.883f, 12.184f, 9.955f, 12.127f, 9.965f)
            curveTo(12.051f, 9.979f, 11.993f, 9.973f, 11.952f, 9.948f)
            lineTo(11.869f, 9.899f)
            verticalLineTo(9.983f)
            curveTo(11.843f, 9.986f, 11.799f, 9.981f, 11.738f, 9.966f)
            lineTo(11.728f, 10.014f)
            lineTo(11.63f, 9.912f)
            curveTo(11.658f, 9.914f, 11.692f, 9.906f, 11.723f, 9.889f)
            curveTo(11.792f, 9.853f, 11.828f, 9.787f, 11.804f, 9.742f)
            curveTo(11.78f, 9.697f, 11.705f, 9.69f, 11.637f, 9.726f)
            curveTo(11.617f, 9.736f, 11.601f, 9.749f, 11.587f, 9.763f)
            curveTo(11.586f, 9.749f, 11.583f, 9.734f, 11.579f, 9.72f)
            curveTo(11.556f, 9.646f, 11.498f, 9.598f, 11.45f, 9.613f)
            curveTo(11.425f, 9.621f, 11.407f, 9.643f, 11.399f, 9.673f)
            lineTo(11.355f, 9.628f)
            lineTo(11.317f, 9.673f)
            lineTo(11.398f, 9.757f)
            curveTo(11.399f, 9.762f, 11.4f, 9.768f, 11.402f, 9.774f)
            curveTo(11.423f, 9.842f, 11.474f, 9.888f, 11.52f, 9.883f)
            lineTo(11.714f, 10.084f)
            lineTo(11.714f, 10.086f)
            lineTo(11.717f, 10.087f)
            lineTo(11.83f, 10.205f)
            curveTo(11.847f, 10.239f, 11.862f, 10.27f, 11.875f, 10.298f)
            curveTo(11.889f, 10.359f, 11.91f, 10.427f, 11.939f, 10.469f)
            curveTo(11.942f, 10.481f, 11.943f, 10.491f, 11.943f, 10.499f)
            curveTo(11.943f, 10.562f, 12.093f, 10.6f, 12.387f, 10.639f)
            curveTo(12.616f, 10.669f, 12.887f, 10.689f, 13.109f, 10.692f)
            verticalLineTo(10.693f)
            lineTo(13.137f, 10.693f)
            lineTo(13.165f, 10.693f)
            verticalLineTo(10.692f)
            curveTo(13.387f, 10.689f, 13.658f, 10.669f, 13.887f, 10.639f)
            curveTo(14.181f, 10.6f, 14.331f, 10.562f, 14.331f, 10.499f)
            curveTo(14.331f, 10.457f, 14.368f, 10.357f, 14.443f, 10.205f)
            lineTo(14.957f, 9.673f)
            lineTo(14.919f, 9.628f)
            lineTo(14.778f, 9.774f)
            curveTo(14.78f, 9.768f, 14.782f, 9.762f, 14.785f, 9.755f)
            curveTo(14.807f, 9.681f, 14.786f, 9.609f, 14.737f, 9.594f)
            curveTo(14.688f, 9.579f, 14.63f, 9.627f, 14.608f, 9.701f)
            curveTo(14.603f, 9.715f, 14.601f, 9.73f, 14.599f, 9.744f)
            curveTo(14.586f, 9.73f, 14.569f, 9.717f, 14.55f, 9.707f)
            curveTo(14.482f, 9.671f, 14.407f, 9.678f, 14.383f, 9.723f)
            curveTo(14.359f, 9.768f, 14.395f, 9.834f, 14.463f, 9.87f)
            curveTo(14.531f, 9.907f, 14.606f, 9.9f, 14.63f, 9.855f)
            lineTo(14.633f, 9.849f)
            curveTo(14.639f, 9.855f, 14.647f, 9.859f, 14.655f, 9.862f)
            curveTo(14.667f, 9.866f, 14.68f, 9.865f, 14.693f, 9.862f)
            lineTo(14.506f, 10.056f)
            lineTo(14.488f, 9.966f)
            curveTo(14.427f, 9.981f, 14.383f, 9.986f, 14.357f, 9.983f)
            verticalLineTo(9.899f)
            lineTo(14.274f, 9.948f)
            curveTo(14.233f, 9.973f, 14.175f, 9.979f, 14.098f, 9.965f)
            curveTo(14.042f, 9.955f, 14.004f, 9.883f, 13.992f, 9.73f)
            lineTo(13.991f, 9.716f)
            curveTo(14.01f, 9.727f, 14.034f, 9.735f, 14.06f, 9.739f)
            curveTo(14.136f, 9.75f, 14.204f, 9.718f, 14.211f, 9.667f)
            curveTo(14.218f, 9.616f, 14.162f, 9.567f, 14.085f, 9.556f)
            curveTo(14.067f, 9.553f, 14.05f, 9.553f, 14.033f, 9.555f)
            curveTo(14.043f, 9.531f, 14.048f, 9.502f, 14.047f, 9.471f)
            curveTo(14.043f, 9.394f, 13.998f, 9.334f, 13.947f, 9.336f)
            curveTo(13.896f, 9.339f, 13.858f, 9.404f, 13.862f, 9.481f)
            curveTo(13.863f, 9.499f, 13.866f, 9.517f, 13.872f, 9.533f)
            curveTo(13.853f, 9.523f, 13.832f, 9.516f, 13.808f, 9.513f)
            curveTo(13.732f, 9.502f, 13.664f, 9.535f, 13.657f, 9.585f)
            curveTo(13.65f, 9.636f, 13.706f, 9.685f, 13.783f, 9.696f)
            curveTo(13.825f, 9.702f, 13.865f, 9.695f, 13.893f, 9.678f)
            lineTo(13.882f, 9.717f)
            curveTo(13.844f, 9.851f, 13.786f, 9.91f, 13.704f, 9.91f)
            curveTo(13.623f, 9.91f, 13.59f, 9.878f, 13.587f, 9.796f)
            lineTo(13.577f, 9.563f)
            lineTo(13.481f, 9.771f)
            curveTo(13.446f, 9.846f, 13.399f, 9.88f, 13.331f, 9.88f)
            curveTo(13.239f, 9.88f, 13.176f, 9.799f, 13.17f, 9.671f)
            curveTo(13.187f, 9.676f, 13.206f, 9.679f, 13.225f, 9.679f)
            curveTo(13.302f, 9.679f, 13.365f, 9.637f, 13.365f, 9.586f)
            curveTo(13.365f, 9.535f, 13.302f, 9.494f, 13.225f, 9.494f)
            curveTo(13.208f, 9.494f, 13.191f, 9.496f, 13.176f, 9.5f)
            curveTo(13.182f, 9.475f, 13.183f, 9.446f, 13.177f, 9.417f)
            curveTo(13.172f, 9.389f, 13.161f, 9.364f, 13.147f, 9.344f)
            horizontalLineTo(13.253f)
            verticalLineTo(9.267f)
            verticalLineTo(8.725f)
            curveTo(13.337f, 8.645f, 13.457f, 8.604f, 13.616f, 8.604f)
            curveTo(13.872f, 8.604f, 13.977f, 8.673f, 14.037f, 8.876f)
            curveTo(14.075f, 9.005f, 14.038f, 9.115f, 13.918f, 9.218f)
            lineTo(13.986f, 9.315f)
            curveTo(14.121f, 9.2f, 14.18f, 9.063f, 14.159f, 8.911f)
            curveTo(14.448f, 8.901f, 14.663f, 8.934f, 14.804f, 9.01f)
            curveTo(14.927f, 9.076f, 14.95f, 9.244f, 14.857f, 9.536f)
            lineTo(14.962f, 9.577f)
            curveTo(15.072f, 9.233f, 15.041f, 9f, 14.853f, 8.9f)
            curveTo(14.688f, 8.811f, 14.448f, 8.775f, 14.13f, 8.789f)
            lineTo(14.131f, 8.798f)
            curveTo(14.05f, 8.569f, 13.901f, 8.481f, 13.616f, 8.481f)
            curveTo(13.471f, 8.481f, 13.35f, 8.512f, 13.253f, 8.574f)
            verticalLineTo(8.543f)
            horizontalLineTo(13.029f)
            verticalLineTo(8.597f)
            curveTo(12.926f, 8.513f, 12.79f, 8.472f, 12.622f, 8.472f)
            curveTo(12.342f, 8.472f, 12.193f, 8.556f, 12.112f, 8.774f)
            lineTo(12.113f, 8.727f)
            curveTo(11.796f, 8.713f, 11.556f, 8.749f, 11.39f, 8.838f)
            curveTo(11.203f, 8.939f, 11.172f, 9.172f, 11.281f, 9.515f)
            lineTo(11.387f, 9.474f)
            curveTo(11.294f, 9.183f, 11.316f, 9.015f, 11.44f, 8.949f)
            curveTo(11.582f, 8.872f, 11.798f, 8.839f, 12.088f, 8.85f)
            curveTo(12.045f, 9.022f, 12.101f, 9.178f, 12.251f, 9.306f)
            lineTo(12.32f, 9.208f)
            curveTo(12.199f, 9.105f, 12.162f, 8.995f, 12.2f, 8.866f)
            close()
            moveTo(13.085f, 9.586f)
            curveTo(13.085f, 9.581f, 13.086f, 9.576f, 13.087f, 9.571f)
            lineTo(13.083f, 9.571f)
            curveTo(13.084f, 9.576f, 13.085f, 9.581f, 13.085f, 9.586f)
            close()
            moveTo(14.467f, 10.096f)
            curveTo(14.375f, 10.114f, 14.309f, 10.112f, 14.274f, 10.081f)
            curveTo(14.219f, 10.098f, 14.154f, 10.1f, 14.08f, 10.087f)
            curveTo(14.002f, 10.073f, 13.947f, 10.015f, 13.914f, 9.92f)
            curveTo(13.871f, 9.98f, 13.817f, 10.017f, 13.752f, 10.029f)
            curveTo(14.11f, 10.085f, 14.361f, 10.164f, 14.361f, 10.164f)
            curveTo(14.361f, 10.164f, 14.355f, 10.222f, 14.34f, 10.291f)
            curveTo(14.356f, 10.255f, 14.375f, 10.215f, 14.396f, 10.171f)
            lineTo(14.402f, 10.163f)
            lineTo(14.467f, 10.096f)
            close()
            moveTo(13.583f, 10.006f)
            curveTo(13.551f, 9.989f, 13.526f, 9.964f, 13.509f, 9.932f)
            curveTo(13.482f, 9.958f, 13.451f, 9.977f, 13.418f, 9.989f)
            curveTo(13.474f, 9.994f, 13.529f, 10f, 13.583f, 10.006f)
            close()
            moveTo(13.22f, 9.977f)
            curveTo(13.176f, 9.955f, 13.14f, 9.919f, 13.113f, 9.874f)
            curveTo(13.086f, 9.919f, 13.05f, 9.954f, 13.007f, 9.977f)
            curveTo(13.033f, 9.976f, 13.058f, 9.975f, 13.084f, 9.975f)
            verticalLineTo(9.975f)
            lineTo(13.106f, 9.975f)
            lineTo(13.129f, 9.975f)
            verticalLineTo(9.975f)
            curveTo(13.16f, 9.975f, 13.19f, 9.976f, 13.22f, 9.977f)
            close()
            moveTo(11.868f, 10.159f)
            lineTo(11.816f, 10.105f)
            curveTo(11.878f, 10.112f, 11.925f, 10.105f, 11.952f, 10.081f)
            curveTo(12.007f, 10.098f, 12.072f, 10.1f, 12.145f, 10.087f)
            curveTo(12.224f, 10.073f, 12.279f, 10.015f, 12.312f, 9.92f)
            curveTo(12.354f, 9.978f, 12.406f, 10.015f, 12.469f, 10.028f)
            curveTo(12.16f, 10.076f, 11.929f, 10.141f, 11.868f, 10.159f)
            close()
            moveTo(12.806f, 9.988f)
            curveTo(12.752f, 9.993f, 12.698f, 9.998f, 12.647f, 10.004f)
            curveTo(12.676f, 9.987f, 12.7f, 9.963f, 12.717f, 9.932f)
            curveTo(12.743f, 9.958f, 12.773f, 9.976f, 12.806f, 9.988f)
            close()
            moveTo(14.184f, 10.5f)
            curveTo(14.223f, 10.52f, 14.254f, 10.5f, 14.279f, 10.461f)
            curveTo(14.277f, 10.472f, 14.276f, 10.481f, 14.275f, 10.49f)
            curveTo(14.272f, 10.493f, 14.267f, 10.495f, 14.26f, 10.498f)
            curveTo(14.242f, 10.507f, 14.214f, 10.516f, 14.177f, 10.525f)
            curveTo(14.105f, 10.543f, 14.002f, 10.561f, 13.881f, 10.577f)
            curveTo(13.643f, 10.609f, 13.361f, 10.629f, 13.137f, 10.631f)
            curveTo(12.913f, 10.629f, 12.63f, 10.609f, 12.393f, 10.577f)
            curveTo(12.272f, 10.561f, 12.169f, 10.543f, 12.097f, 10.525f)
            curveTo(12.066f, 10.517f, 12.042f, 10.51f, 12.024f, 10.503f)
            lineTo(12.03f, 10.5f)
            curveTo(12.152f, 10.437f, 12.961f, 10.378f, 13.106f, 10.368f)
            curveTo(13.252f, 10.378f, 14.061f, 10.437f, 14.184f, 10.5f)
            close()
            moveTo(14.346f, 10.488f)
            lineTo(14.345f, 10.49f)
            lineTo(14.346f, 10.489f)
            lineTo(14.346f, 10.488f)
            close()
        }
        path(fill = SolidColor(Color.White)) {
            moveTo(12.127f, 8.677f)
            lineTo(12.126f, 8.739f)
            curveTo(11.63f, 8.729f, 11.345f, 8.809f, 11.273f, 8.968f)
            curveTo(11.198f, 9.132f, 11.212f, 9.332f, 11.316f, 9.569f)
            lineTo(11.266f, 9.596f)
            curveTo(11.154f, 9.343f, 11.139f, 9.123f, 11.223f, 8.94f)
            curveTo(11.308f, 8.751f, 11.61f, 8.667f, 12.127f, 8.677f)
            close()
        }
        path(fill = SolidColor(Color.White)) {
            moveTo(12.223f, 9.223f)
            lineTo(12.195f, 9.276f)
            curveTo(12.087f, 9.205f, 12.032f, 9.084f, 12.032f, 8.917f)
            curveTo(12.032f, 8.677f, 12.145f, 8.536f, 12.394f, 8.44f)
            curveTo(12.552f, 8.378f, 12.769f, 8.403f, 13.045f, 8.513f)
            lineTo(13.025f, 8.571f)
            curveTo(12.761f, 8.466f, 12.556f, 8.442f, 12.412f, 8.498f)
            curveTo(12.184f, 8.586f, 12.088f, 8.706f, 12.088f, 8.917f)
            curveTo(12.088f, 9.064f, 12.133f, 9.164f, 12.223f, 9.223f)
            close()
        }
        path(fill = SolidColor(Color.White)) {
            moveTo(14.082f, 8.739f)
            lineTo(14.083f, 8.8f)
            curveTo(14.579f, 8.791f, 14.864f, 8.87f, 14.936f, 9.029f)
            curveTo(15.011f, 9.194f, 14.997f, 9.393f, 14.892f, 9.631f)
            lineTo(14.943f, 9.657f)
            curveTo(15.054f, 9.404f, 15.07f, 9.185f, 14.986f, 9.002f)
            curveTo(14.9f, 8.813f, 14.599f, 8.729f, 14.082f, 8.739f)
            close()
        }
        path(fill = SolidColor(Color.White)) {
            moveTo(13.906f, 9.236f)
            lineTo(13.935f, 9.289f)
            curveTo(14.043f, 9.218f, 14.097f, 9.097f, 14.097f, 8.93f)
            curveTo(14.097f, 8.69f, 13.985f, 8.549f, 13.736f, 8.452f)
            curveTo(13.577f, 8.391f, 13.361f, 8.416f, 13.085f, 8.526f)
            lineTo(13.104f, 8.584f)
            curveTo(13.369f, 8.478f, 13.573f, 8.455f, 13.717f, 8.51f)
            curveTo(13.946f, 8.599f, 14.041f, 8.719f, 14.041f, 8.93f)
            curveTo(14.041f, 9.076f, 13.996f, 9.177f, 13.906f, 9.236f)
            close()
        }
    }.build()
}

@Preview
@Composable
private fun BritishIndianOceanTerritoryPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.BritishIndianOceanTerritory,
            contentDescription = "British Indian Ocean Territory Flag"
        )
    }
}
